module.exports = __webpack_public_path__ + "img/user_bg_tc.3b4afc74.png";